module.exports = __webpack_public_path__ + "static/media/tribe_truck_end.af1be473.png";